import moment from "moment";
import contentStatic from "./util-content-static";
import _ from "lodash";
import React from "react";

const jQuery = window.jQuery;

const contentDynamic = {
  renderModal: renderModal,
  renderShowsNames: renderShowsNames,
  returnCleanTimeSlot: returnCleanTimeSlot,
  returnCleanTimeSlots: returnCleanTimeSlots,
  returnShowNames: returnShowNames,
  returnLineNumber: returnLineNumber,
  returnChangeLogPath: returnChangeLogPath,
  returnPaginationUrl: returnPaginationUrl,
  returnPodStatus: returnPodStatus,
  returnSpotStatus: returnSpotStatus,
  returnRepeatValue: returnRepeatValue,
  returnSimpleSelectOptions: returnSimpleSelectOptions,
  returnSimpleSelectOptionsForShows: returnSimpleSelectOptionsForShows,
  returnSimpleSelectOptionsForSpots: returnSimpleSelectOptionsForSpots,
  returnSortClass: returnSortClass,
  returnSortValue: returnSortValue,
  returnSunday: returnSunday,
  alertInfo: alertInfo,
  alertPodInfo: alertPodInfo,
  formatVideoError: formatVideoError
};

export default contentDynamic;

//

// return a jQuery object used to insert into the page;
function renderModal(
  title,
  body,
  buttonTextDefault,
  buttonTextLoading,
  iconClass
) {
  const $modal = jQuery(`<div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">${title}</h4>
        </div>
        <div class="modal-body">
          ${body}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <button
            type="button"
            class="btn btn-danger"
            data-loading-text="<i class='fa fa-spinner fa-spin'></i> <i class='fa ${iconClass}'></i> ${buttonTextLoading}">
            <i class="fa ${iconClass}" aria-hidden="true"></i>
            ${buttonTextDefault}
          </button>
        </div>
      </div>
    </div>
  </div>`);

  // once the modal is closed, remove it from the DOM;
  // one and done modal;
  $modal.on(`hidden.bs.modal`, () => {
    $modal.remove();
  });

  return $modal;
}

// used by returnSortClass and returnSortValue because the default value may be either;
function returnCleanedSortValue(sort) {
  const asc = sort.replace(`-`, ``);

  return {
    asc: asc,
    desc: `-${asc}`
  };
}

// remove the seconds from a time slot (we never want to display those);
function returnCleanTimeSlot(timeslot = ``) {
  return timeslot.replace(`:00`, ``);
}

// remove the seconds from all the time slots in the array;
function returnCleanTimeSlots(timeslots = []) {
  const newTimeslots = [];

  timeslots &&
    timeslots.forEach(timeslot => {
      newTimeslots.push(returnCleanTimeSlot(timeslot));
    });

  return newTimeslots;
}

// getting the Shows names
function returnShowNames(shows) {
  const showNames = [];

  shows &&
    shows.forEach(show => {
      showNames.push(show.label);
    });

  return showNames;
}

function renderShowsNames(shows) {
  const showNames = returnShowNames(shows);

  let showsList = null;
  showsList = showNames.map((show, index) => <div key={index}> {show} </div>);
  // only displaying the first 2 Shows
  // and add '...' at the end, for longer list of Shows
  if (showNames.length > 2) {
    showsList = showsList.splice(0, 2);
    showsList.push(<div key={2}> ... </div>);
  }
  return showsList;
}

// return 1 -> X for table row numbers;
// page 1 will be 1 -> 20, page 5 will be 101 -> 120 (when resultsPerPage = 20);
function returnLineNumber(currentPage, resultsPerPage, index) {
  return (currentPage - 1) * resultsPerPage + (index + 1);
}

// find the object based off the Django content_type value;
// of find the object by the path in the url;
function returnChangeLogPath(contentType) {
  let pathObj = ``;

  contentStatic.objectTypes.forEach(obj => {
    if (obj.key === contentType || obj.path === contentType) {
      pathObj = obj;
    }
  });

  return pathObj;
}

// function used by all three pagination links;
// works for components with and without sort;
function returnPaginationUrl(path, page, search) {
  let url = `/${path}/${page}/`;

  if (search) {
    url = `${url}${search}`;
  }

  return url;
}

// transform pod status ids into text;
function returnPodStatus(index = 0) {
  return contentStatic.podStatuses[index].label;
}

function returnSpotStatus(index = 0) {
  return contentStatic.podStatuses[index].label;
}

// transform rule repeat ids into text;
function returnRepeatValue(id) {
  const repeatValues = [
    `N/A`, // 0 - not in use;
    `Monthly`, // 1
    `Weekly`, // 2
    `Daily` // 3
  ];

  return repeatValues[id];
}

// add label/value properties to each object in the array;
// used in the SimpleSelect components;
function returnSimpleSelectOptions(options) {
  const newOptions = [];

  options.forEach(option => {
    newOptions.push({
      label: option.name,
      value: option.id,
      id: option.id.toString()
    });
  });

  return newOptions;
}

function returnSimpleSelectOptionsForShows(options) {
  const newOptions = [];

  options.forEach(option => {
    newOptions.push({
      label: option.title,
      value: option.program_id,
      id: option.program_id.toString()
    });
  });

  return newOptions;
}

function returnSimpleSelectOptionsForSpots(options) {
  const newOptions = [];

  options.forEach(option => {
    let duration_s = (option.duration / 1000).toFixed(2);
    newOptions.push({
      label: `${option.name} (${duration_s} s)`,
      value: option.id,
      id: option.id.toString(),
      pod: 0,
      element_id: option.element_id,
      client_name: option.client_name,
      spot_name: option.name,
      protrack_id: option.protrack_id,
      tape: option.tape,
      duration: duration_s.toString()
    });
  });

  return newOptions;
}

// used by all sortable tables;
// returns a class (default, asc, desc) based on current values;
function returnSortClass(newSort, currentSort) {
  const cleanedSort = returnCleanedSortValue(newSort);
  let className = `sort`;

  if (cleanedSort.asc === currentSort) {
    className = `sort-asc`;
  } else if (cleanedSort.desc === currentSort) {
    className = `sort-desc`;
  }

  return className;
}

// used by all sortable lists;
// reverses the sort if it is the currently selected one;
// newSort may be negative so we need to base our variations off of an altered version of it;
function returnSortValue(newSort, currentSort) {
  const cleanedSort = returnCleanedSortValue(newSort);
  let returnSort = newSort;

  // change the value if this sort link is the current sort;
  if (currentSort === cleanedSort.asc || currentSort === cleanedSort.desc) {
    returnSort =
      currentSort === cleanedSort.asc ? cleanedSort.desc : cleanedSort.asc;
  }

  return returnSort;
}

// convert date to a sunday;
// and adjust by week;
function returnSunday(date = new Date(), week = 0) {
  const setToSunday = 0;
  const setToWeek = week * 7;

  return moment(date)
    .day(setToSunday)
    .day(setToWeek)
    .format(contentStatic.dateFormatComputer);
}

// text notification function;
// will display a notification in a Bootstrap `alert` component;
function alertInfo(text) {
  // create the container for the info message;
  const $alert = jQuery(`
    <div class="alert alert-info alert-dismissible" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="alert__info-messages"></div>
    </div>`);

  const $message = `<pre>${text}</pre>`;

  $alert.find(`.alert__info-messages`).prepend($message);

  // now that the error message has been determined and built, insert it into the page;
  // this is outside of React;
  jQuery(`.alert-container`).prepend($alert);
}

// text notification function;
// will display a notification in a Bootstrap `success` or a `danger`(fail) component;
function alertPodInfo(text, status) {
  // create the container for the info message;
  const $alert = jQuery(`
    <div class="alert alert-${status} alert-dismissible" role="alert">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="alert__pod-messages"></div>
    </div>`);

  const $message = `<pre>${text}</pre>`;

  $alert.find(`.alert__pod-messages`).prepend($message);

  // now that the error message has been determined and built, insert it into the page;
  // this is outside of React;
  jQuery(`.alert-container`).prepend($alert);

  // it will get auto-removed after 60 seconds
  setTimeout(() => {
    $alert.remove();
  }, 60000);
}

function formatVideoError(statusMessage) {
  if (typeof statusMessage != "string") {
    console.warn(
      "formatVideoError received strange value ",
      typeof statusMessage
    );
    return [];
  }

  if (!statusMessage) {
    return [];
  }

  // need to convert the message to JSON so we can display only the relevant parts;
  // convert error JSON into an error message;
  let messageStatus = {};
  const errors = [];

  try {
    messageStatus = JSON.parse(
      statusMessage.replace(`File verification failed: `, ``).replace(/'/g, `"`)
    );
  } catch (e) {
    // fallback to displaying the raw error message if it's not a valid json
    return [statusMessage];
  }

  // if video is present in the errors, only display video errors;
  if (messageStatus.Video) {
    Object.keys(messageStatus.Video).forEach((key, index) => {
      errors.push(messageStatus.Video[key][0]);
    });
  }
  // if audio is present, and general is not, only display audio errors with a prefix;
  else if (messageStatus.Audio && messageStatus.General === undefined) {
    Object.keys(messageStatus.Audio).forEach((key, index) => {
      errors.push(`<strong>Audio:</strong> ${messageStatus.Audio[key][0]}`);
    });
  }
  // otherwise display all errors;
  else {
    Object.keys(messageStatus).forEach((statusKey, index) => {
      Object.keys(messageStatus[statusKey]).forEach((typeKey, index) => {
        errors.push(messageStatus[statusKey][typeKey][0]);
      });
    });
  }

  // remove any duplicate errors (the same error can be part of video/audio/general);
  const displayErrors = _.uniq(errors);

  return displayErrors;
}
